import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'component-drop-down',
  templateUrl: './component-drop-down.component.html',
  styleUrl: './component-drop-down.component.scss',
  standalone: false
})
export class ComponentDropDownComponent {

  @Input()
  set ViewModel(viewModel: DropDownViewModel) {
    this.viewModel = viewModel;
  }

  @Output() ValueChange: EventEmitter<any> = new EventEmitter<any>();

  viewModel: DropDownViewModel;

  onChange(event: Event) {
    this.ValueChange.emit(this.viewModel.Value);
  }
}

export class DropDownViewModel {
  Value: any;
  AvailableList: { Value: { Key: any; Value: string }[] };
}